import { render, staticRenderFns } from "./AddContractorToCompanyMarketplace.vue?vue&type=template&id=76885a4e"
import script from "./AddContractorToCompanyMarketplace.vue?vue&type=script&lang=ts"
export * from "./AddContractorToCompanyMarketplace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76885a4e')) {
      api.createRecord('76885a4e', component.options)
    } else {
      api.reload('76885a4e', component.options)
    }
    module.hot.accept("./AddContractorToCompanyMarketplace.vue?vue&type=template&id=76885a4e", function () {
      api.rerender('76885a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/AddContractorToCompanyMarketplace.vue"
export default component.exports